import { useEffect, useState } from "react";
import api from "../../services/api.js";
import btnClear from "../../assets/clear.png";
import "../autocomplete-franquia-proj/autocomplete-franquia-proj.css"

function AutocompleteFranquiaProj(props) {

    const [texto, setTexto] = useState("");
    const [dadosFranquias, setDadosFranquias] = useState([]); //todas as franquias geral    

    function ListarFranquiasGeral(buscaFranquia) {//somente id e nome para montar combo

        if (buscaFranquia.length > 2) {
            api.get("/franquia_busca_autocomplete/", { params: { buscaFranquia } })
                .then((resp) => {
                    setDadosFranquias(resp.data);
                    //console.log(resp.data)
                })
                .catch((err) => {
                    setDadosFranquias([]);
                    alert("Erro ao carregar dados");
                });
        }
    }

    function Filtrar(e) {
        setTexto(e.target.value);
        ListarFranquiasGeral(e.target.value);
    }

    function SelecionarFranquia(id, nome_franquia, cidade_franquia) {
        localStorage.setItem('id_franquia_autocomplete', id);
        setTexto(nome_franquia); //para preencher o input de busca
        setDadosFranquias([]); //fecha caixa relaçao franquias  
        props.onClickId(id); // para enviar o id para a tela franquias
        props.onClickNome(nome_franquia);     
    }

    function Clear() {
        setTexto("");
        props.onClickId(0);
        props.onClickNome("");
        props.onClickUrl(""); //para limpar url do frame
        setDadosFranquias([]);
   
    }

    useEffect(() => {
        document.addEventListener('click', (e) => setDadosFranquias([])); // quando clicar fora da tela de resultado fecha a mesma zerando o array
    }, []);

    return <div className="autocomplete-franquia col-12">
        <input type="text" className="form-control" onChange={Filtrar}
            placeholder={props.placeholder} value={texto} />

        <div className="autocomplete-franquia-items">
            {
                dadosFranquias.map((item) => {
                    return <div key={item.id_franquia}
                        className="autocomplete-franquia-item"
                        onClick={(e) => SelecionarFranquia(item.id_franquia, item.nome_franquia, item.cidade_franquia)}
                    >
                        <b>{item.nome_franquia}</b><br />
                        <small className="text-secondary">Cidade: {item.cidade_franquia}</small><br />
                        <small className="text-secondary">Código: {item.id_franquia}</small>
                    </div>
                })
            }
        </div>
        {
            texto.length > 0 ?
                <button className="autocomplete-franquia-clear" onClick={Clear}>
                    <img src={btnClear} className="autocomplete-franquia-img" />
                </button>
                : null
        }
    </div>
}

export default AutocompleteFranquiaProj;